module.exports = __webpack_public_path__ + "static/media/tree-alt.f0f5e81a.svg";